import { FC } from 'react';
import { useExpertProfileStore } from 'shared/hooks/stores/useExpertProfileStore';
import { AvatarPlaceholder } from 'shared/icons';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface AvatarProps {
  className?: string;
  size?: number;
}

export const Avatar: FC<AvatarProps> = ({ className = '', size = 50 }) => {
  const avatarUrl = useExpertProfileStore((store) => store.expertProfile?.avatarUrl);

  return (
    <div
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
      }}
      className={mergeClasses('overflow-hidden rounded-full bg-lightBlue', className)}
    >
      {avatarUrl ? (
        <img alt="User avatar" className="h-full w-full object-cover" src={avatarUrl} />
      ) : (
        <AvatarPlaceholder />
      )}
    </div>
  );
};
